<t4-header icon="glyphicon-stats"></t4-header>
<t4-periodPicker period="day" [(from)]="from" [(to)]="to" (periodChanged)="updateParams()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl reportName="RentalReport" [parameters]="queryParameters" headline="" [autoGenerateColumns]="true" matSort [filterFields]="['Id', 'RegNo', 'Location', 'EndTime','StartTime']">

    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>Rental</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> <t4-booking-link style="min-width:90px;" bookingId="{{row.Id}}">{{row.Id}}</t4-booking-link> </mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="RentalObjectId">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>RegNo</mat-header-cell>
      <mat-cell style="min-width: 90px;" *matCellDef="let row"><t4-object-link style="min-width:90px;" [objectId]="row.RentalObjectId">{{ row.RegNo }}</t4-object-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="RentalLocationId">
      <mat-header-cell *matHeaderCellDef style="min-width: 250px;" mat-sort-header>Location</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 250px;"><t4-location-link style="min-width:90px;" [locationId]="row.RentalLocationId">{{ row.Location }}</t4-location-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 250px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="StartTime">
      <mat-header-cell *matHeaderCellDef style="min-width: 145px;" mat-sort-header>StartTime</mat-header-cell>
      <mat-cell style="min-width: 145px; " *matCellDef="let row">{{ row.StartTime | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 145px; font-weight: bold; background: #eee "></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="EndTime">
      <mat-header-cell *matHeaderCellDef style="min-width: 145px;" mat-sort-header>EndTime</mat-header-cell>
      <mat-cell style="min-width: 145px;" *matCellDef="let row">{{ row.EndTime | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 145px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Location" style="width:0;">
      <mat-header-cell *matHeaderCellDef style="width: 0;"></mat-header-cell>
      <mat-cell *matCellDef="let row"></mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="RegNo" style="width:0;">
      <mat-header-cell *matHeaderCellDef style="width: 0;"></mat-header-cell>
      <mat-cell *matCellDef="let row"></mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

  </t4-data-table>
</t4-container>
